import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-floating mb-3" }
const _hoisted_2 = ["value"]



import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'DinamicaRBXForm',
  props: {
  modelValue: {
    type: Object,
    required: false,
    default: undefined
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const safeModelValue = computed(() => {
  return props.modelValue && typeof props.modelValue === 'object'
    ? { ...props.modelValue, cause: props.modelValue.cause || '' }
    : { cause: '' };
});

function onCauseChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:modelValue', { ...safeModelValue.value, cause: value });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      class: "form-select",
      id: "floatingSelect",
      value: safeModelValue.value.cause,
      onChange: onCauseChange
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("option", {
        disabled: "",
        value: ""
      }, "Selecione a causa", -1),
      _createElementVNode("option", { value: "780" }, "780 - (FALH TRANSP OPE) - Falha transporte operadora/parceiro", -1),
      _createElementVNode("option", { value: "781" }, "781 - (FALH OP TRANSIT) - Falha operadora trânsito", -1),
      _createElementVNode("option", { value: "185" }, "185 - (REPARO FIELD) - Necessidade de reparo em campo", -1)
    ]), 40, _hoisted_2),
    _cache[1] || (_cache[1] = _createElementVNode("label", { for: "floatingSelect" }, "Causa", -1))
  ]))
}
}

})